import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Config } from '@luggagehero/shared/environment';
import { SharedNotificationService } from '@luggagehero/shared/services/notification';
import { SharedUserService } from '@luggagehero/shared/services/users';
import { SharedWindowService } from '@luggagehero/shared/services/window';
import { TranslateService } from '@ngx-translate/core';
import { FileUploader } from 'ng2-file-upload';

import { BaseComponent } from '../../../core';
import { StorageManagerService } from '../../../services/index';
import { ManageableStorageLocation } from '../../../services/storage-manager/storage-location';

@Component({ template: '' })
export abstract class ImagesBaseComponent extends BaseComponent implements OnInit {
  @Output() imagesChange: EventEmitter<string[]> = new EventEmitter<string[]>();
  @Output() isUploadingChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  uploader: FileUploader;
  hasBaseDropZoneOver = false;
  hasAnotherDropZoneOver = false;
  readonly imageUrl: string;
  uploadProgress: number = null;

  private _shop: ManageableStorageLocation;
  private _images: string[];

  constructor(
    private userService: SharedUserService,
    private storageManager: StorageManagerService,
    private windowService: SharedWindowService,
    private notify: SharedNotificationService,
    private translate: TranslateService,
    private cd: ChangeDetectorRef,
  ) {
    super();
    this.imageUrl = `${Config.environment.IMAGES_BASE_URL}/images`;
  }

  get shop(): ManageableStorageLocation {
    return this._shop;
  }
  @Input() set shop(value: ManageableStorageLocation) {
    this._shop = value;
    if (this.uploader) {
      this.uploader.options.url = this.imageUploadUrl;
    }
    this.images = this.shop.images;
  }

  get images(): string[] {
    return this._images;
  }
  set images(value: string[]) {
    this._images = value;
    this.cd.markForCheck();
    this.imagesChange.emit(value);
  }

  get imageUploadUrl(): string {
    return `${Config.environment.STORAGE_MANAGER_API}/storage_locations/${this.shop._id}/images`;
  }

  ngOnInit() {
    this.uploader = new FileUploader({
      url: '',
      authToken: `Bearer ${this.userService.accessToken}`,
      isHTML5: true,
      maxFileSize: 5 * 1024 * 1024,
      allowedMimeType: ['image/png', 'image/jpg', 'image/jpeg', 'image/gif'],
      autoUpload: true,
      removeAfterUpload: true,
    });
    if (this.shop && this.shop._id) {
      this.uploader.options.url = this.imageUploadUrl;
    }
    this.uploader.onProgressAll = (progress: number) => {
      this.uploadProgress = progress;
      this.cd.markForCheck();
    };
    this.uploader.onCompleteAll = () => {
      this.uploadProgress = null;
      void this.storageManager.getStorageLocation(this.shop._id, true).then((res) => {
        this.shop = res;
        this.cd.markForCheck();
      });
    };
    this.uploader.onWhenAddingFileFailed = (item) => {
      if (item.size > this.uploader.options.maxFileSize) {
        const mb = (item.size / 1024 / 1024).toFixed(2);
        this.notify.chat(`${item.name} (${mb} MB)`, this.translate.instant('FILE_TOO_LARGE') as string);
      } else {
        this.notify.chat(item.name, this.translate.instant('UPLOAD_FAILED') as string);
      }
    };
    this.uploader.onErrorItem = (item) => {
      this.notify.chat(item.file.name, this.translate.instant('UPLOAD_FAILED') as string);
    };
    this.uploader.onSuccessItem = (_item) => {
      // this.notify.success(`${this.translate.instant('UPLOAD_SUCCEEDED')}: ${item.file.name}`);
    };
  }

  async removeImage(imageName: string) {
    const message = this.translate.instant('CONFIRM_REMOVE_IMAGE') as string;

    try {
      // Wait for user to confirm the delete operation
      this.windowService.confirm(message);

      this.shop = await this.storageManager.deleteImage(this.shop._id, imageName);
    } catch {
      // User canceled, do nothing
    }
  }
}
